export const search = {
  Songs: 'Lieder',
  Playlists: 'Wiedergabelisten',
  'Top Result': 'Bester Treffer',
  'No results': 'Keine Ergebnisse',
  'No results where found for': 'Keine Ergebnisse gefunden für',
};
